import React, { useEffect, useRef } from "react";

import * as d3 from "d3";

type DataPoint = {
  value: number;
  date: Date;
};

type IndicatorProps = {
  data: DataPoint[];
  yScale: d3.ScaleLinear<number, number>;
  xScale: d3.ScaleTime<number, number>;
  adaptedCursor?: { snapDate?: Date };
  serviceName?: string;
};

const Indicator = (props: IndicatorProps) => {
  const { data, yScale, xScale, adaptedCursor } = props;

  const indicatorRef = useRef(null);
  const snapDate = adaptedCursor?.snapDate;

  useEffect(() => {
    if (!data || data.length === 0) return;

    const indicatorGroup = d3.select(indicatorRef.current);

    // Add circle indicators for EVERY data point
    indicatorGroup
      .selectAll("circle")
      .data(data)
      .join("circle")
      .attr("cx", d => xScale(d.date))
      .attr("cy", d => yScale(d.value || 0))
      .attr("r", 3)
      .attr("fill", "var(--section-graph-2-fill,var(--graph-2))")
      .attr("stroke", "var(--snow)")
      .attr("stroke-width", 1)
      .attr("opacity", ({ date }) =>
        date.getTime() === snapDate?.getTime() ? 1 : 0
      );
  }, [data, xScale, yScale, snapDate]);

  return <g ref={indicatorRef} />;
};

export default Indicator;
